import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Instruction = styled.b`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.bold};
    font-size: ${theme.v2.font.sizes.sm2};
  `}
`;

export const InputWrapper = styled.div`
  &:hover{
    cursor: pointer;
  }
`;

export const BarCode = styled.img`
  width: 100%;
  height: 68px;
`;

export const PaymentTips = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    padding: 0 0 0 16px;
    list-style: none;
  `}
`;

export const TipItem = styled.li`
  display: flex;
  gap: 8px;
`;

export const Number = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    background-color: ${theme.v2.colors.brand.primaryExtraDark};
    font-weight: ${theme.v2.font.weights.bold};
    font-size: ${theme.v2.font.sizes.xxs};
  `}
`;

export const TipText = styled.div`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: 16px;

    @media (max-width: ${theme.v1.breakpoints.sm}){
      flex-direction: column;
    }
  `}
`;
